import React from "react";
import { Field, formValueSelector } from "redux-form";
import { Row, Col, Collapse } from "react-bootstrap";
import { update } from "MODULES/RMAsAndWarranties/actions";
import {
  form,
  Form as AppForm,
  Check,
  CheckGroup,
  Select,
  CurrencyField
} from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import {
  REPAIR_STATION_WARRANTY_STATUS,
  VENDOR_WARRANTY_AMOUNT,
  VENDOR_WARRANTY_AMOUNT_PAID,
  WARRANTY_CHARGES_INVOICED,
  WARRANTY_STATUS,
  WARRANTY_STATUSES
} from "MODULES/RMAsAndWarranties/constants";
import { WARRANTY_CONSIDERATION } from "MODULES/RepairOrders/constants";
import { properCase } from "LIB/formatters/text";
import { connect } from "react-redux";
import { DENIED } from "MODULES/companies/constants";

export function Form({ rma, warrantyStatus, ...props }) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row className="row-col-gutters-half">
          <Col md={6}>
            <CheckGroup justified title="Warranty Consideration?">
              <Field
                name="warranty_consideration"
                component={Check}
                label="Yes"
              />
            </CheckGroup>
          </Col>
          {warrantyStatus === DENIED && (
            <Col md={6}>
              <CurrencyField
                name={VENDOR_WARRANTY_AMOUNT_PAID}
                label="Warranty Amount Paid"
              />
            </Col>
          )}
          {!rma.shipped &&
            rma.type === "CustomerRma" && (
              <Col md={5}>
                <CheckGroup title="Warranty Charges Invoiced?" justified>
                  <Field
                    name={WARRANTY_CHARGES_INVOICED}
                    component={Check}
                    label="Yes"
                  />
                </CheckGroup>
              </Col>
            )}
        </Row>
        <Field
          name={WARRANTY_CONSIDERATION}
          component={({ input }) => (
            <Collapse in={!!input.value}>
              <div>
                <Row className="row-col-gutters-half">
                  <Col md={6}>
                    <Field
                      name={WARRANTY_STATUS}
                      component={Select}
                      options={toOptions(WARRANTY_STATUSES)}
                      label={properCase(WARRANTY_STATUS)}
                    />
                  </Col>
                  {rma.type === "CustomerRma" &&
                    !rma.shipped && (
                      <Col md={6}>
                        <Field
                          name={REPAIR_STATION_WARRANTY_STATUS}
                          component={Select}
                          options={toOptions(WARRANTY_STATUSES)}
                          label="Repair Station Warranty"
                        />
                      </Col>
                    )}

                  {warrantyStatus === DENIED && (
                    <Col md={6}>
                      <CheckGroup justified title="Warranty Amount Paid?">
                        <Field
                          name="warranty_amount_paid"
                          component={Check}
                          label="Yes"
                        />
                      </CheckGroup>
                    </Col>
                  )}
                </Row>
              </div>
            </Collapse>
          )}
        />
        <Row className="row-col-gutters-half">
          {rma.shipped &&
            warrantyStatus === DENIED && (
              <Col md={6}>
                <CurrencyField
                  name={VENDOR_WARRANTY_AMOUNT}
                  label="Warranty Amount"
                />
              </Col>
            )}
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

const FORM_NAME = "rmaWarrantyConsideration";

const selector = formValueSelector(FORM_NAME);

export default connect(
  state => ({
    warrantyStatus: selector(state, WARRANTY_STATUS)
  }),
  dispatch => ({
    onSubmit: values => dispatch(update(values))
  })
)(
  form({
    form: FORM_NAME
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/WarrantyConsideration/Form.jsx